@if (text) {
  <div class="element-message {{ styleClassName }}">

    @if (!showConfirmation) {
      <div class="element-message__text">
        {{ text }}
      </div>

      @if (variant !== 'placeholder') {
        <div class="element-message__actions">
          <app-button (clicked)="editClick.emit()" faIcon="far fa-pencil" [iconOnly]="true" variant="secondary" size="sm"></app-button>
          <app-button (clicked)="toggleConfirmation()" faIcon="far fa-trash" [iconOnly]="true" variant="info" size="sm"></app-button>
        </div>
      }
    } @else {
      <div class="element-message__text">
        Are you sure you wish to remove this notification?
      </div>

      <div class="element-message__actions">
        <app-button (clicked)="onCancelRemove()" text="No, Cancel" variant="info" size="sm"></app-button>
        <app-button (clicked)="onConfirmRemove()" text="Yes, Remove" variant="primary" size="sm"></app-button>
      </div>
    }
  </div>
}
